// Helpers for "show info popup only the first time" behaviour (per faInfoKey).
// Reason: each Filing Assistant info popup should educate the user once, then
// subsequent clicks jump straight to the underlying action.

const STORAGE_PREFIX = 'faInfoSeen:';

// Returns true if the info popup for this key has already been shown before.
export const hasSeenFaInfo = (key) => {
    try {
        return localStorage.getItem(`${STORAGE_PREFIX}${key}`) === '1';
    } catch (error) {
        return false;
    }
};

// Marks the info popup for this key as seen so it is skipped next time.
export const markFaInfoSeen = (key) => {
    try {
        localStorage.setItem(`${STORAGE_PREFIX}${key}`, '1');
    } catch (error) { /* ignore storage errors (private mode, quota) */ }
};

// Decides whether to open the info popup or run the action directly.
// First time for a given key -> open the popup (and mark it seen).
// Afterwards -> run the action immediately, skipping the popup.
export const openFaInfoOrRun = (key, { openInfo, runAction }) => {
    if (hasSeenFaInfo(key)) return runAction(key);
    markFaInfoSeen(key);
    return openInfo(key);
};
